import { useLocation, useNavigate } from 'react-router-dom';

export const useDialogOpen = (name: string) => {
  const nav = useNavigate();
  const location = useLocation();

  const setDialogOpen = (value: boolean) => {
    const params = new URLSearchParams();
    if (value) {
      params.append('dialog', name);
    } else {
      params.delete('dialog');
    }

    nav({
      pathname: location.pathname,
      search: params.toString(),
    });
  };
  return { setDialogOpen };
};

export default useDialogOpen;
